var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1729 13.5889C9.84744 13.9144 9.3196 13.9144 8.99416 13.5889L3.99416 8.58893C3.66894 8.26353 3.66894 7.73659 3.99416 7.4112C4.3196 7.08576 4.84744 7.08576 5.17287 7.4112L9.58303 11.8214L13.9942 7.4112C14.3196 7.08576 14.8474 7.08576 15.1729 7.4112C15.4979 7.73655 15.4979 8.26358 15.1729 8.58893L10.1729 13.5889Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.a8e2a733cda171e9e1cd94eb3d752185.svg";
export { ForwardRef as ReactComponent };